<list-view *ngIf="listeMotifs" [liste]="listeMotifs"></list-view>
<floating-button [listeActions]="listeActions"></floating-button>